import { render, staticRenderFns } from "./AulaList.vue?vue&type=template&id=d7ad750a&scoped=true&"
import script from "./AulaList.vue?vue&type=script&lang=js&"
export * from "./AulaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ad750a",
  null
  
)

export default component.exports